import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueLocalStorage from 'vue-localstorage'
import VModal from 'vue-js-modal'
import VueCordova from 'vue-cordova'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// plugin setup
Vue.use(VueRouter)
// Vue.use(VueLocalStorage)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.use(VueCordova)
Vue.use(LightBootstrap)

var isApp = (document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1)
if (isApp) {
  var scriptCordova = document.createElement('script')
  scriptCordova.type = 'text/javascript'
  scriptCordova.src = 'cordova.js'
  document.getElementsByTagName('head')[0].appendChild(scriptCordova)
}

// Codice barra dei cookie - Inizio
var scriptCookie = document.createElement('script')
scriptCookie.id = 'Cookiebot'
scriptCookie.src = 'https://consent.cookiebot.com/uc.js'
scriptCookie.setAttribute('data-cbid', 'fb8788e6-7561-429e-a2ca-593a31300cc9')
scriptCookie.type = 'text/javascript'
document.getElementsByTagName('head')[0].appendChild(scriptCookie)
// Codice barra dei cookie - Fine

// configure router
const router = new VueRouter({
  // routes, // short for routes: routes, lo eseguo nel file GlobalMixin
  linkActiveClass: 'nav-item active',
  base: process.env.BASE_ROUTE
})

const scrollableElementId = 'main-panel' // You should change this
const scrollPositions = Object.create(null)

window.addEventListener('popstate', () => {
  let currentRouteName = router.history.current.name

  let element = document.getElementById(scrollableElementId)
  if (element !== null && currentRouteName in scrollPositions) {
    var scrollFn = function () {
      element.scrollTop = scrollPositions[currentRouteName]
    }
    setTimeout(scrollFn, 100)
    setTimeout(scrollFn, 300)
  }
})

router.beforeEach((to, from, next) => {
  let element = document.getElementById(scrollableElementId)
  if (element !== null) {
    scrollPositions[from.name] = element.scrollTop
    element.scrollTop = 0
  }
  if (to.matched.some(record => (record.path === '/login'))) {
    if (vm.isAuth) {
      next({
        path: '/dashboard/home'
      })
      return
    }
  }
  if (to.matched.some(record => (record.path === '/dashboard/home'))) {
    if (!vm.isAuth) {
      next({
        path: '/login'
      })
      return
    }
  }
  if (to.matched.some(record => (record.meta.requiresAuth || record.meta.requiresAuthType))) {
    if (!vm.isAuth) {
      next({
        path: '/notauthorized'
      })
    } else {
      for (var i in to.matched) {
        var arrayType = to.matched[i].meta.requiresAuthType
        if (!vm.checkAuthType(arrayType)) {
          next({
            path: '/notauthorized'
          })
          return
        }
      }
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  data: {
    user: null,
    isApp: isApp,
    cordova: Vue.cordova
  },
  computed: {
    isAuth: function () {
      if (this.user) {
        return true
      }
      return false
    }
  },
  methods: {
  }
})

vm.checkLogin()




// WEBPACK FOOTER //
// ./src/main.js